export default __webpack_public_path__ + "static/media/withdrawal-bnb-rosn.632efe94.svg";